export const EmptyState = ({ icon: Icon, title, description, action, testid = 'empty-state' }) => (
  <div className="flex flex-col items-center text-center py-16 px-6" data-testid={testid}>
    {Icon && (
      <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-5 text-primary">
        <Icon className="h-7 w-7" strokeWidth={1.5} />
      </div>
    )}
    <h3 className="font-heading text-xl font-semibold mb-2">{title}</h3>
    {description && <p className="text-sm text-muted-foreground max-w-sm mb-6">{description}</p>}
    {action}
  </div>
);
